/**
 * DATEI: assets/load-more.js
 * Native Web Component für schrittweises Nachladen via Section Rendering API
 */
if (!customElements.get('load-more')) {
  customElements.define('load-more', class LoadMore extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('[data-load-more-btn]');
      this.loader = this.querySelector('[data-loader]');
      this.buttonText = this.querySelector('.load-more-text');
      this.gridId = this.dataset.gridId;
      this.sectionId = this.dataset.sectionId;

      if (this.button) {
        this.button.addEventListener('click', this.onClick.bind(this));
      }
    }

    async onClick(e) {
      e.preventDefault();
      const url = this.button.getAttribute('href');

      if (!url || this.button.classList.contains('is-loading')) return;

      this.toggleLoading(true);

      try {
        // Nutzung der Section Rendering API für optimierte Payload
        const response = await fetch(`${url}&section_id=${this.sectionId}`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        // Produkte an Grid anhängen
        const newProducts = html.querySelectorAll(`#${this.gridId} > *`);
        const targetGrid = document.getElementById(this.gridId);

        if (targetGrid && newProducts.length > 0) {
          newProducts.forEach(product => targetGrid.appendChild(product));
        }

        // Nächste Pagination-URL aktualisieren oder Button entfernen
        const nextLoadMore = html.querySelector('load-more');
        const nextButton = nextLoadMore ? nextLoadMore.querySelector('[data-load-more-btn]') : null;

        if (nextButton) {
          this.button.setAttribute('href', nextButton.getAttribute('href'));
        } else {
          this.remove(); // Keine weiteren Produkte vorhanden
        }

      } catch (error) {
        console.error('Fehler beim Laden weiterer Produkte:', error);
      } finally {
        this.toggleLoading(false);
      }
    }

    toggleLoading(isLoading) {
      if (isLoading) {
        this.button.classList.add('is-loading');
        if (this.loader) this.loader.classList.remove('hidden');
        if (this.buttonText) this.buttonText.style.opacity = '0';
      } else {
        this.button.classList.remove('is-loading');
        if (this.loader) this.loader.classList.add('hidden');
        if (this.buttonText) this.buttonText.style.opacity = '1';
      }
    }
  });
}